export enum EditorExtensionEnum {
  Document = 'document',
  Paragraph = 'paragraph',
  Text = 'text',
  Bold = 'bold',
  Italic = 'italic',
  Strike = 'strike',
  Underline = 'underline',
  Color = 'color',
  Link = 'link',
}
